/**
 * Exports a readonly list of available entrypoints
 */
export default Object.freeze({
    widget: '/widget',
    newspaper: '/newspaper',
});
